/**
 * 确认对话框组件 — 基于 MUI Dialog。
 * 用于投放计划确认操作。
 */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

export interface ConfirmDialogProps {
  /** 是否打开。 */
  open: boolean;
  /** 标题。 */
  title: string;
  /** 内容描述。 */
  content: string;
  /** 确认按钮文字。 */
  confirmText?: string;
  /** 取消按钮文字。 */
  cancelText?: string;
  /** 确认回调。 */
  onConfirm: () => void;
  /** 取消回调。 */
  onCancel: () => void;
  /** 是否正在加载。 */
  loading?: boolean;
}

export default function ConfirmDialog({
  open,
  title,
  content,
  confirmText = "确认",
  cancelText = "取消",
  onConfirm,
  onCancel,
  loading = false,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: 16, fontWeight: 600 }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 13, color: "text.secondary" }}>
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onCancel} disabled={loading} color="inherit">
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? "处理中..." : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
